
import Inicio from '../views/Inicio.vue'
import Login from '../views/Login.vue'
import Inscripcion from '../views/Inscripcion.vue'
import Actualizar from '../views/Actualizar.vue'
import NotFound from '../views/NotFound.vue'
import store from "../store";
const updateRoutes = () => {
  return new Promise((resolve, reject) => {
    store
      .dispatch("fetchInscripciones")
      .then(() => {
        const data = [
          {
            path: "/",
            name: "Inicio",
            component: Inicio,
          },
          {
            path: `/registro/:estrategia${store.getters.getSlugRegex}`,
            name: "Login",
            component: Login
          },
          {
            path: `/inscripción/:estrategia${store.getters.getSlugRegex}`,
            name: "Inscripcion",
            component: Inscripcion,

          },
          {
            path: `/actualizar/:estrategia${store.getters.getSlugRegex}`,
            name: "Actualización",
            component: Actualizar
          },
          {
            path: "*",
            name: "Not Found",
            component: NotFound
          }
        ];
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export default updateRoutes;
